module.exports = __webpack_public_path__ + "img/hz_22.f9c4055e.jpg";